import Cookies from 'js-cookie';

class storageManager {
  getItem(){
    throw new Error('getValue method should be implemented');
  }
  setItem(){
    throw new Error('setValue method should be implemented');
  }
  removeItem(){
    throw new Error('removeValue method should be implemented');
  }
}

class cookiesStorageManager extends storageManager {
  constructor() {
    super();
  }

  getItem(key) {
    return Cookies.get(key) ?? null;
  }

  setItem(key, value, options = {}) {
    Cookies.set(key, value, options);
  }

  removeItem(key) {
    Cookies.remove(key);
  }
}

export default new cookiesStorageManager();